<template>
  <default-layout>
    <v-layout wrap>
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">New Category</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <editor @data="save" :loading="loading" :initial="category"></editor>
    </v-layout>
    <v-btn fab fixed bottom right dark class="pink" to="/categories">
      <v-icon>close</v-icon>
    </v-btn>
  </default-layout>
</template>

<script>
import Editor from "../_components/editor.vue";
export default {
  name: "CreateCategoryPage",
  components: {
    Editor
  },
  data() {
    return {
      category: {},
      loading: false
    };
  },
  methods: {
    save(data) {
      this.loading = true;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/expertise", data })
        .then(res => {
          self.category = {};
          self.loading = false;
           this.$router.push('/categories')
        })
        .finally(() => {
          
        });
    }
  }
};
</script>